import React from 'react';
import { object } from 'prop-types';

import { BQLink } from '../../atoms/bqlink';
import CardImage from '../../atoms/cardimage';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { getHeadline, getStorySlug, getAuthor } from '../../../helpers/utils';

import './videoCardImageHeadlineAuthor.m.css';
import { contentClick } from '../../../helpers/datalayer-utils';

const VideoCardImageHeadlineAuthor = ({ story }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  const authorObj = getAuthor(story);

  return (
    <div styleName="wrapper" className="card-image-headline-horizontal" >
      <BQLink href={getStorySlug(story)}>
        <div onClick={() => contentClick(userData, story, pageType)} data-nosnippet>
          <CardImage
            story={story}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            isPlayIcon={true}
            isLazy={false}
          />
        </div>
      </BQLink>

      <div styleName="content">
        <div onClick={() => contentClick(userData, story, pageType)}>
          <BQLink href={getStorySlug(story)} styleName="headline">
            {getHeadline(story, true)}
          </BQLink>
        </div>
        {authorObj ? (
          <BQLink styleName="by-author" href={authorObj.authorSlug}>
            {authorObj.name}
          </BQLink>
        ) : null}
      </div>
    </div>
  );
};

VideoCardImageHeadlineAuthor.propTypes = {
  story: object.isRequired
};

export default VideoCardImageHeadlineAuthor;
